import { constMap } from './../utils/index.js';
// prettier-ignore
const nativeDecimalEntries = [
    ["Evm", 18],
    ["Solana", 9],
    ["Sui", 9],
    ["Aptos", 8],
    ["Cosmwasm", 6],
    ["Algorand", 6],
    ["Btc", 8],
    ["Near", 12],
];
/** Number of decimals for the native token on a given platform */
export const nativeDecimals = constMap(nativeDecimalEntries);
//# sourceMappingURL=decimals.js.map